import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const WA_SVG = (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

function DemoBuchenPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.cal.com/embed/embed.js';
    script.async = true;
    script.onload = () => {
      if (window.Cal) {
        window.Cal('init', 'frontup-demo-termin', { origin: 'https://cal.com' });
        window.Cal.ns['frontup-demo-termin']('inline', {
          elementOrSelector: '#cal-embed',
          calLink: 'frontup/frontup-demo-termin',
          layout: 'month_view',
        });
      }
    };
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <Nav />

      <div style={{background:'#fff',borderBottom:'1px solid var(--border)',padding:'80px 40px 64px'}}>
        <div style={{maxWidth:900,margin:'0 auto'}}>
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:14}}>Demo</div>
          <h1 style={{fontSize:'clamp(40px,5vw,60px)',fontWeight:800,letterSpacing:'-2px',lineHeight:1.05,color:'#111',marginBottom:14}}>Demo buchen.</h1>
          <p style={{fontSize:18,color:'#888',lineHeight:1.65,maxWidth:520,marginBottom:40}}>Buch dir 20 Minuten mit mir. Ich zeige dir live wie FrontUp für dein Unternehmen funktioniert – persönlich, direkt, ohne Umwege.</p>

          {/* CAL.COM EMBED */}
          <div style={{background:'#f7f7f7',border:'1.5px solid var(--border)',borderRadius:16,overflow:'hidden',minHeight:600}}>
            <div id="cal-embed" style={{minWidth:320,height:700}}></div>
          </div>

          {/* ALTERNATIVE: WhatsApp */}
          <div style={{marginTop:24,background:'#111',borderRadius:14,padding:'28px 32px',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:16}}>
            <div>
              <div style={{fontSize:16,fontWeight:700,color:'#fff',marginBottom:4}}>Lieber direkt schreiben?</div>
              <div style={{fontSize:14,color:'rgba(255,255,255,.45)'}}>Schreib mir auf WhatsApp – ich antworte persönlich.</div>
            </div>
            <a href="https://wa.me/491791548222" target="_blank" rel="noreferrer" className="btn-whatsapp" style={{fontSize:15,padding:'12px 24px'}}>
              {WA_SVG}
              Jetzt auf WhatsApp
            </a>
          </div>

          <div style={{marginTop:14,textAlign:'center'}}>
            <button onClick={() => navigate('/')} style={{background:'none',border:'none',fontSize:14,color:'#aaa',cursor:'pointer',fontFamily:'inherit'}}>← Zurück zur Startseite</button>
          </div>
        </div>
      </div>

      <Footer simple />
    </>
  );
}

export default DemoBuchenPage;
